var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 15.203a10.4 10.4 0 0 1 20.8 0 .8.8 0 1 0 1.6 0 12 12 0 0 0-24 0 .8.8 0 1 0 1.6 0zm10.4-6.4a6.4 6.4 0 0 0-6.4 6.4.8.8 0 1 1-1.6 0 8 8 0 0 1 16 0 .8.8 0 1 1-1.6 0 6.4 6.4 0 0 0-6.4-6.4zm-3.6 6a3.6 3.6 0 1 1 4.4 3.51v2.49h6.4a4 4 0 0 1 0 8H8.8a4 4 0 1 1 0-8h6.4v-2.49a3.6 3.6 0 0 1-2.8-3.51zm3.6-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7.2 9.6a2.4 2.4 0 0 0 0 4.8h14.4a2.4 2.4 0 1 0 0-4.8H8.8z",
    fill: "url(#fcf0r4myma)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.825 22.36H23.6a2 2 0 0 1 2 2v.843a2 2 0 0 1-2 2H9.825V22.36z",
    fill: "url(#pix5ku5wvb)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcf0r4myma",
    x1: 4,
    y1: 18.09,
    x2: 28.096,
    y2: 10.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pix5ku5wvb",
    x1: 9.825,
    y1: 25.176,
    x2: 17.956,
    y2: 16.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkSettingsIcon);
export default __webpack_public_path__ + "static/media/networkSettingsIcon.bda2fe38c3467cad166b53b343d0213b.svg";
export { ForwardRef as ReactComponent };